export class DataCalculFraisDePortCommandeDenreeModel {
  idGroupeAchat_CatalogueAchat: number;
  dateLivraisonPossible: Date;
  quantiteUC: number;
  idFournisseur: number;
  idCatalogueAchat: number;
  ratioUC: number;
}
